<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>

    <nav class="navbar navbar-expand-lg navbar-dark">
      <div class="container-xl">
        <div class="navbar-brand" style="overflow-block: hidden; max-width: 75%">1Click : Easy to Get Information & Connection</div>
        <!--m_menu-->
        <button
          v-if="isUserMenuActive"
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarsExample07XL"
          aria-controls="navbarsExample07XL"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <!--end m_menu-->
      </div>
      <div v-if="isUserMenuActive" id="navbarsExample07XL" class="collapse navbar-collapse">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="#" @click="enableUpdateMode">{{$t('edit')}}</a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="container pb-1">

<!--      <div v-if="status==='Landing'" class="row">-->

<!--        <div class="col-12 order-md-1">-->

<!--          <div class="mainlogo" />-->

<!--          <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">-->

<!--            <div class="carousel-indicators">-->
<!--              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>-->
<!--              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>-->
<!--              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>-->
<!--            </div>-->

<!--            <div class="carousel-inner">-->

<!--              <div class="carousel-item active">-->
<!--                <div class="card pb-5">-->
<!--                  <div class="card_img" style="background-image: url('/images/index1.jpg')"></div>-->
<!--                  <div class="card-body">-->
<!--                    <p class="card-text">-->
<!--                      - {{$t('userTrackingAct.description1')}}<br>-->
<!--                      - {{$t('userTrackingAct.description2')}}-->
<!--                    </p>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="carousel-item">-->
<!--                <div class="card pb-5">-->
<!--                  <div class="card_img" style="background-image: url('/images/index2.jpg')"></div>-->
<!--                  <div class="card-body">-->
<!--                    <p class="card-text">-->
<!--                      - {{$t('userTrackingAct.description3')}}<br>-->
<!--                      - {{$t('userTrackingAct.description4')}}-->
<!--                    </p>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="carousel-item">-->
<!--                <div class="card pb-5">-->
<!--                  <div class="card_img" style="background-image: url('/images/index3.jpg')"></div>-->
<!--                  <div class="card-body">-->
<!--                    <p class="card-text">-->
<!--                      - {{$t('userTrackingAct.description5')}}<br>-->
<!--                      - {{$t('userTrackingAct.description6')}}-->
<!--                    </p>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->

<!--          <div class="d-grid gap-2 mt-4">-->
<!--            <button class="btn btn-primary btn-lg" type="button" v-on:click="changeStatus('TermsAndCondition')" >{{$t('userTrackingAct.next')}}</button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div v-if="status==='TermsAndCondition'" class="row">

        <div class="col-12 order-md-1">

          <div class="mainlogo"></div>

          <div class="jumbotron text-dark">
            <h2>{{showName}}</h2>
            <h3>{{$t('userTrackingAct.declarationTitle')}}</h3><br>
            <p>{{$t('userTrackingAct.declarationDetail1')}}</p>
            <p>{{$t('userTrackingAct.declarationDetail2')}}{{showName}}{{$t('userTrackingAct.declarationDetail3')}}{{showName}}{{$t('userTrackingAct.declarationDetail4')}}{{showName}}{{$t('userTrackingAct.declarationDetail5')}}</p>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="isCheckedTermOfUse" id="invalidCheck" required>
              <label class="form-check-label small" for="invalidCheck">
                {{$t('userTrackingAct.termOfUse1')}} <a :href="termsPage" target="_blank">{{$t('userTrackingAct.termOfUse2')}}</a><br>{{$t('userTrackingAct.termOfUse3')}}
              </label>
              <div class="invalid-feedback">{{$t('userTrackingAct.termOfUse4')}}</div>
            </div>
          </div>

          <button class="btn btn-primary btn-lg btn-block mt-4" type="button" :disabled="!isCheckedTermOfUse" v-on:click="checkTermsAndCondition">{{$t('userTrackingAct.termOfUse1')}}</button>

        </div>

      </div>

      <div v-else class="row pt-3">

        <div v-if="isUserMenuActive && status !== 'UserProfileUpdate'" class="col-12 order-md-1">
          <h4 class="mb-3">{{ showName }}</h4>
<!--          <div class="mainViewCover"><img class="img-fluid" :src="visualIdentifyImage" /></div>-->
          <div class="d-flex flex-column mb-4">
            <img :src="boothCompanyLogo" class="img-thumbnail storelogo mt-3 mb-3 mx-auto" style="max-width: 45%; height: auto">
            <h3 class="mx-auto">{{ companyName }}</h3>
            <h5 class="mx-auto text-black-50">{{exhibitionArea}}</h5>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="agreeFeedback" checked>
              <label class="form-check-label" for="agreeFeedback">
                {{ $t('userTrackingAct.requestFor1') }}<br>
                {{ $t('userTrackingAct.requestFor2') }}
              </label>
            </div>
          </div>

          <button class="btn btn-primary btn-lg btn-block mt-4" type="button" v-on:click="addVisitorTrackingLog">{{$t('userTrackingAct.confirm')}}</button>

        </div>

        <div v-if="status != 'ExistingUser'" class="col-12 order-md-1">
          <h4 class="mb-3">{{ showName }}</h4>

          <div class="mainViewCover"><img class="img-fluid" :src="visualIdentifyImage" /></div>

          <form class="needs-validation" novalidate @submit.prevent="submit">
            <span v-if="stage === 'I'">
            <p>{{ $t('userTrackingAct.inputNotice') }}</p>
              <!-- userName -->
              <div class="form-group">
                <label for="username">{{ $t('userTrackingAct.userName') }}</label>
                <!--有錯誤的時候 class 加上is-invalid 就可以-->
                <input
                  id="username"
                  v-model="userName"
                  type="text"
                  class="form-control"
                  :placeholder="$t('userTrackingAct.userNamePlaceHolder')"
                  required
                  :readonly="isUserMenuActive && status !== 'UserProfileUpdate'"
                />
                <div class="invalid-feedback">{{$t('userTrackingAct.userNamePlaceHolder')}}</div>
              </div>
              <!-- email -->
              <div class="form-group">
                <label for="usermail">{{$t('userTrackingAct.userEmail')}}</label>
                <input
                  id="usermail"
                  v-model="userEmail"
                  type="email"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  class="form-control"
                  :placeholder="$t('userTrackingAct.userEmailPlaceHolder')"
                  required
                  :readonly="isUserMenuActive && status !== 'UserProfileUpdate'"
                />
                <small id="usermailHelp"
                       class="form-text text-muted">{{$t('userTrackingAct.userEmailNotice')}}</small>
                <div class="invalid-feedback">{{$t('userTrackingAct.userEmailPlaceHolder')}}</div>
              </div>
              <!-- mobile number -->
              <div class="form-group">
                <label for="userphone">{{$t('userTrackingAct.userPhone')}}</label>
                <input
                  id="userphone"
                  v-model="userPhoneNumber"
                  type="tel"
                  pattern="^(d+-?)+d+$"
                  class="form-control"
                  :placeholder="$t('userTrackingAct.userPhonePlaceHolder')"
                  required
                  :readonly="isUserMenuActive && status !== 'UserProfileUpdate'"
                />
                <div class="invalid-feedback">{{$t('userTrackingAct.userPhonePlaceHolder')}}</div>
              </div>
              <!-- Next step -->
              <button class="btn btn-primary btn-lg btn-block mt-4" id="nextStepBtn" type="button" v-on:click="changeStage('S2')">{{$t('userTrackingAct.next1')}}</button>
            </span>

            <span v-if="stage === 'S2'">
              <!-- company name -->
              <div class="form-group">
                <label for="usercompany">{{$t('userTrackingAct.userCompany')}}</label>
                <input
                  id="usercompany"
                  v-model="userCompany"
                  type="text"
                  class="form-control"
                  :placeholder="$t('userTrackingAct.userCompanyPlaceHolder')"
                  required
                  :readonly="isUserMenuActive && status !== 'UserProfileUpdate'"
                />
                <div class="invalid-feedback">{{$t('userTrackingAct.userCompanyPlaceHolder')}}</div>
              </div>
              <!-- job title -->
              <div class="form-group">
                <label for="userCareer">{{$t('userTrackingAct.userJobTitle')}}</label>
                <select
                  id="userCareer"
                  v-model="userCareer"
                  class="form-control"
                  required
                  :disabled="isUserMenuActive && status !== 'UserProfileUpdate'"
                >
                  <option v-for="obj in jobTitleOptions" v-bind:key="obj.ITEM_KEY" :value="obj.ITEM_KEY">{{obj.ITEM_VALUE}}</option>
                </select>
                <div class="invalid-feedback">{{$t('userTrackingAct.userJobTitlePlaceHolder')}}</div>
              </div>
              <!-- industry -->
              <div class="form-group">
                <label for="userindustry">{{$t('userTrackingAct.userIndustry')}}</label>
                <select
                  id="userindustry"
                  v-model="companyIndustry"
                  class="form-control"
                  required
                  :disabled="isUserMenuActive && status !== 'UserProfileUpdate'"
                >
                  <option v-for="obj in industryOptions" v-bind:key="obj.ITEM_KEY" :value="obj.ITEM_KEY">{{obj.ITEM_VALUE}}</option>
                </select>
                <div class="invalid-feedback">{{$t('userTrackingAct.userIndustryPlaceHolder')}}</div>
              </div>

              <button class="btn btn-primary btn-lg btn-block mt-4" id="submitBtn" type="submit">
                {{$t('userTrackingAct.confirm')}}
              </button>

              <button class="btn btn-light btn-lg btn-block mt-4" id="previousStepBtn" v-on:click="changeStage('I')" type="button">{{$t('userTrackingAct.back')}}</button>
            </span>

          </form>
        </div>

      </div>

      <footer class="my-5 pt-5 text-muted small">
        <p class="mb-1">{{$t('companyName')}}</p>
        <p class="mb-3">
          Email: info@yscreatech.com
        </p>
        <p class="mb-1">© 2014-2022 Young Square Createch LTD.</p>
      </footer>
      <div class="login_power">©2014-2022 Young Square Createch Ltd.</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UUID from "vue-uuid";
import moment from "moment";
import { ImmortalDB } from "immortal-db";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(UUID);

export default {
  name: "UserTrackingActRevamp",
  components: {
    Loading,
  },
  data: function () {
    return {
      isUserMenuActive: false,
      status: "",
      deviceFingerPrint: "",
      showId: "",
      showName: "",
      visualIdentifyImage: "",
      boothId: "",
      boothCompanyLogo: null,
      boothProfileType: "",
      boothContactPerson: "",
      boothContactNumber: "",
      boothOfficialSite: "",
      boothAddress: "",
      exhibitionArea: "",
      userName: "",
      userCompany: "",
      userCareer: "",
      userEmail: "",
      userPhoneNumber: "",
      companyName: "",
      companyIndustry: "",
      requestInfoFlag: true,
      isLoading: false,
      fullPage: true,
      isAgreeForPolicy: true,
      createdDate: null,
      catalogues: null,
      stage: "",
      isCheckedTermOfUse: false,
      jobTitleOptions: [],
      industryOptions: [],
      termsPage: navigator.language.substring(0, 2) === 'zh' ? "terms.html" : "terms_en.html"
    };
  },
  async created() {
    this.boothId = this.$route.params.boothId;
    this.initialBoothProfile(this.$route.params.boothId);
    await ImmortalDB.get("YSCT_FINGER_TermsOfUse").then(async (key) => {
      if (key !== 'Yes') {
        this.status = "TermsAndCondition";
        this.stage = "I";
      } else {
        ImmortalDB.get("YSCT_FINGER_PRINT").then((key) => {
          if (key !== null) {
            this.deviceFingerPrint = key;
            this.queryVisitorProfile(key);
          } else {
            this.status = "NewUser";
            this.stage = "I";
          }
        });
      }
    });
  },
  beforeMount() {
    this.isLoading = true;
  },
  updated() {
    let forms = document.getElementsByClassName("needs-validation");
    if(forms !== undefined) {
      Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    }
    this.createdDate = new Date();
    this.isLoading = false;
  },
  methods: {
    moment: function () {
      return moment();
    },
    changeStatus: function (s) {
      this.status = s;
    },
    changeStage: function (s) {
      this.stage = s;
    },
    checkTermsAndCondition: async function () {
      await ImmortalDB.set("YSCT_FINGER_TermsOfUse", "Yes").then(() => {
        this.changeStatus("NewUser");
      });
    },
    initialBoothProfile: function (boothId) {
      const data = { SID: boothId };
      this.$BoothAPI
        .queryBoothProfile(data)
        .then((res) => {
          const resultStr = res.data;
          const resultObj = JSON.parse(resultStr);
          if (resultObj.body.MESSAGE === "SUCCESS") {
            this.showId = resultObj.body.SHOW.SID;
            this.showName = resultObj.body.SHOW.SHOW_LOCAL_NAME;
            if(navigator.language.substring(0,2) !== resultObj.body.SHOW.DEFAULT_LANG) {
              this.showName = resultObj.body.SHOW.SHOW_ENG_NAME;
            }
            this.visualIdentifyImage = resultObj.body.SHOW.VISUAL_IDENTITY_IMAGE;
            this.companyName = resultObj.body.COMPANY_NAME;
            if(resultObj.body.COMPANY_LOGO !== "") {
              this.boothCompanyLogo = '/logo/' + this.showId + "/" + resultObj.body.COMPANY_LOGO;
            }
            this.exhibitionArea = resultObj.body.EXHIBITION_AREA;
            this.catalogues = resultObj.body.CATALOGUES;
            this.boothProfileType = resultObj.body.PROFILE_TYPE;
            this.boothContactPerson = resultObj.body.CONTACT_PERSON;
            this.boothContactNumber = resultObj.body.CONTACT_NUMBER;
            this.boothOfficialSite = resultObj.body.OFFICIAL_SITE;
            this.boothAddress = resultObj.body.ADDRESS;
            this.jobTitleOptions = resultObj.body.SHOW.JOB_TITLE_OPTIONS.en;
            if (resultObj.body.SHOW.JOB_TITLE_OPTIONS[navigator.language.substring(0, 2)] !== null
            ) {
              this.jobTitleOptions = resultObj.body.SHOW.JOB_TITLE_OPTIONS[navigator.language.substring(0, 2)];
            }
            this.industryOptions = resultObj.body.SHOW.INDUSTRY_OPTIONS.en;
            if (resultObj.body.SHOW.INDUSTRY_OPTIONS[navigator.language.substring(0, 2)] !== null
            ) {
              this.industryOptions = resultObj.body.SHOW.INDUSTRY_OPTIONS[navigator.language.substring(0, 2)];
            }
          } else {
            this.$alert.warningAlert(resultObj.body.MESSAGE);
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
    enableUpdateMode: function () {
      this.status = "UserProfileUpdate";
      this.changeStage("I");
    },
    async submit() {
      if (
        this.userName.length !== 0 &&
        this.userCompany.length !== 0 &&
        this.userCareer.length !== 0 &&
        this.userEmail.length !== 0 &&
        this.userPhoneNumber.length !== 0 &&
        this.companyIndustry.length !== 0 &&
        (this.isUserMenuActive || this.isAgreeForPolicy)
      ) {
        this.isLoading = true;

        if (this.status === "NewUser") {
          await this.addVisitorProfile();
          this.isUserMenuActive = true;
        } else if (this.status === "UserProfileUpdate") {
          this.updateUserProfile();
        }
      } else {
        console.log("Missed parameters");
      }
    },
    queryVisitorProfile: function (key) {
      const data = {
        SID: key,
      };
      this.$VisitorProfileAPI
        .queryVisitorProfile(data)
        .then((res) => {
          const resultStr = res.data;
          const resultObj = JSON.parse(resultStr);
          if (resultObj.body.MESSAGE === "SUCCESS") {
            this.userName = resultObj.body.USER_NAME;
            this.userCompany = resultObj.body.COMPANY_NAME;
            this.userCareer = resultObj.body.JOB_TITLE;
            this.userEmail = resultObj.body.EMAIL;
            this.userPhoneNumber = resultObj.body.PHONE_NUMBER;
            this.companyIndustry = resultObj.body.COMPANY_INDUSTRY;
            this.status = "ExistingUser";
            this.isUserMenuActive = true;
          } else {
            this.$alert.warningAlert(resultObj.body.MESSAGE);
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
    addVisitorProfile: async function () {
      const fingerPrint = this.$uuid.v4();
      this.deviceFingerPrint = fingerPrint;
      await ImmortalDB.set("YSCT_FINGER_PRINT", fingerPrint).then(() => {
        const data = {
          SID: fingerPrint,
          USER_NAME: this.userName,
          COMPANY_NAME: this.userCompany,
          JOB_TITLE: this.userCareer,
          EMAIL: this.userEmail,
          PHONE_NUMBER: this.userPhoneNumber,
          COMPANY_INDUSTRY: this.companyIndustry,
          DEFAULT_LANG: navigator.language,
        };
        this.$VisitorProfileAPI
          .addVisitorProfile(data)
          .then((res) => {
            const resultStr = res.data;
            const resultObj = JSON.parse(resultStr);
            if (resultObj.body.MESSAGE === "SUCCESS") {
              this.isLoading = false;
              this.status = "ExistingUser";
              this.stage = "";
            } else {
              this.$alert.warningAlert(resultObj.body.MESSAGE);
            }
          })
          .catch((error) => {
            this.$alert.warningAlert(error);
            console.error(error);
          });
      });
    },
    updateUserProfile: function () {
      const data = {
        SID: this.deviceFingerPrint,
        USER_NAME: this.userName,
        COMPANY_NAME: this.userCompany,
        JOB_TITLE: this.userCareer,
        EMAIL: this.userEmail,
        PHONE_NUMBER: this.userPhoneNumber,
        COMPANY_INDUSTRY: this.companyIndustry,
        DEFAULT_LANG: navigator.language,
      };
      this.$VisitorProfileAPI
        .updateVisitorProfile(data)
        .then((res) => {
          const resultStr = res.data;
          const resultObj = JSON.parse(resultStr);
          if (resultObj.body.MESSAGE === "SUCCESS") {
            this.isLoading = false;
            this.status = "ExistingUser";
            this.stage = "";
          } else {
            this.$alert.warningAlert(resultObj.body.MESSAGE);
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
    addVisitorTrackingLog: async function () {
      const data = {
        USER_SID: this.deviceFingerPrint,
        SHOW_SID: this.showId,
        BOOTH_SID: this.boothId,
        REQUEST_INFO_FLAG: this.requestInfoFlag,
        OPEN_CATALOGUE_SRC: null,
        CATELOGUE_SID: null,
        OPEN_VISIT_HISTORY_FLAG: null,
      };
      this.$VisitorProfileAPI
        .addVisitorTrackingLog(data)
        .then((res) => {
          const resultStr = res.data;
          const resultObj = JSON.parse(resultStr);
          if (resultObj.body.MESSAGE === "SUCCESS") {
            this.redirect();
          } else {
            this.$alert.warningAlert(resultObj.body.MESSAGE);
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
    redirect: function () {
      this.$router.push({
        name: "BoothBoardAdmission",
        params: {
          USER_NAME: this.userName,
          SHOW_NAME: this.showName,
          SHOW_SID: this.showId,
          CREATE_DATE: this.createdDate,
          CATALOGUES: this.catalogues,
          BOOTH_NAME: this.companyName,
          BOOTH_COMPANY_LOGO: this.boothCompanyLogo,
          PROFILE_TYPE: this.boothProfileType,
          CONTACT_PERSON: this.boothContactPerson,
          CONTACT_NUMBER: this.boothContactNumber,
          OFFICIAL_SITE: this.boothOfficialSite,
          ADDRESS: this.boothAddress,
          EXHIBITION_AREA: this.exhibitionArea,
        },
      });
    },
    validEmail: function (email) {
      const re =
        /^(([^<>()[].,;:s@"]+(.[^<>()[].,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>
